<!-- <p>exisiting-visitor-dialog works!</p> -->
<div
  [ngClass]="{
    'existing-visitor-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'existing-visitor-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <h2>
    Visitor: {{ visitorData.firstName + " " + visitorData.lastName }} Re-Visit!
  </h2>
  <mat-divider></mat-divider>
  <div
    [ngClass]="{
      'existing-visitor-content':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
      'existing-visitor-content-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <div class="visitor-img-container">
      <img [src]="visitorData.profilePicture" alt="" />
    </div>
    <div class="existing-visitor-form">
      <form [formGroup]="existingVisitorForm">
        <mat-form-field hideRequiredMarker appearance="outline">
          <mat-label>Purpose</mat-label>
          <!-- <input
                  matInput
                  formControlName="purpose"
                />  -->
          <mat-select formControlName="purpose">
            <mat-option value="Personal"> Personal </mat-option>
            <mat-option value="Official"> Official </mat-option>
            <mat-option value="Delivery"> Delivery </mat-option>
            <mat-option value="Meeting"> Meeting </mat-option>
            <mat-option value="Private"> Private </mat-option>
            <mat-option value="Classified"> Classified </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field hideRequiredMarker appearance="outline">
          <mat-label>Meeting With</mat-label>
          <input
            matInput
            [formControl]="hostFilter"
            [matAutocomplete]="autoAdmin"
          />
          <mat-autocomplete
            (optionSelected)="hostSelect($event)"
            #autoAdmin="matAutocomplete"
          >
            <mat-option
              *ngFor="let host of filteredHosts"
              [value]="host.firstname + ' ' + host.lastname"
            >
              {{ host.firstname + " " + host.lastname }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" class="invite-form-fields">
          <mat-label>Pass Validity</mat-label>
          <input
            matInput
            readonly
            formControlName="newEPassValidity"
            [matDatepicker]="Datepicker"
            [min]="minDate"
            [max]="maxDate"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="Datepicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #Datepicker></mat-datepicker>
        </mat-form-field>
      </form>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="exisiting-visitor-actions">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button
      [mat-dialog-close]="this.existingVisitorForm.value"
      mat-raised-button
    >
      Invite
    </button>
  </div>
</div>
